import React from 'react'
import propTypes from "prop-types";
import { Alert, Form, Input, Modal } from 'antd';
import { URL_AUTH } from '../../constants/urls';
import { POST } from '../../frameworks/HttpClient';
import { useTranslation } from 'react-i18next';

export default function ChangePasswordModal(props) {
	const [form] = Form.useForm();
	const [errorMessages, setErrorMessages] = React.useState(null);
	const { t, i18n } = useTranslation();

	const formItemLayout = {
		labelCol: {
			xs: { span: 24 },
			sm: { span: 8 },
		},
		wrapperCol: {
			xs: { span: 24 },
			sm: { span: 16 },
		},
	};

	const handlePasswordChange = async () => {
		setErrorMessages(null);
		try {
			const data = await form.validateFields();
			await POST(props.url, data);
			props.onClose();
		} catch (error) {
			if (error.errorMessages) 
				setErrorMessages(error.errorMessages);
		}
	}

	React.useEffect(() => {
		if (!props.open && form) {
			form.resetFields();
			setErrorMessages(null);
		}
	}, [props.open])

	return (
		<Modal 
			title={t("change_password")}
			open={props.open}
			onCancel={props.onClose}
			cancelText={t("cancel")}
			okText={t("change_password")}
			onOk={handlePasswordChange} >
				{errorMessages && 
					<Alert
						message={errorMessages}
						type="error"
						showIcon
						style={{marginBottom: "12px", textAlign: "left"}}
					/>
				}
				<Form 
					{...formItemLayout}
					form={form}
					onFinish={handlePasswordChange}>
					<Form.Item 
						label={t("new_password")}
						name={"new_password"} 
						rules={[
						{
							required: true,
							message: t("alert_password"),
						},
        		]}>
						<Input.Password />
					</Form.Item>

					<Form.Item 
						label={t("confirm_password")}
						name={"confirm_password"} 
						dependencies={['new_password']}
						hasFeedback
						rules={[
							{
								required: true,
								message: t("alert_password"),
							},
							({ getFieldValue }) => ({
								validator(_, value) {
									if (!value || getFieldValue('new_password') === value) {
										return Promise.resolve();
									}
									return Promise.reject(new Error(t("not_match_password")));
								},
							}),
						]}>
						<Input.Password />
					</Form.Item>
				</Form>
		</Modal>
	)
}

ChangePasswordModal.defaultProps = {
	open: false,
	url: URL_AUTH.CHANGE_PASSWORD,
	onClose: () => {}
}

ChangePasswordModal.propTypes = {
	open: propTypes.bool,
	url: propTypes.string,
	onClose: propTypes.func,
}